import { parseGeoData } from "senf-shared";

export const cleanFeatureCollection = (gisData) => {
  if (!gisData) return null;
  const parsedGisData = parseGeoData(gisData);

  const validateGeometry = (geometry) => {
    const { type, coordinates } = geometry;

    if (
      !type ||
      !coordinates ||
      !Array.isArray(coordinates) ||
      coordinates.length === 0
    ) {
      return false;
    }

    switch (type) {
      case "Point":
        return (
          Array.isArray(coordinates) &&
          coordinates.length === 2 &&
          coordinates.every((val) => typeof val === "number" && val !== null)
        );
      case "LineString":
        return (
          Array.isArray(coordinates) &&
          coordinates.length >= 2 &&
          coordinates.every(
            (coord) =>
              Array.isArray(coord) &&
              coord.length === 2 &&
              coord.every((val) => typeof val === "number" && val !== null)
          )
        );
      case "Polygon":
        return coordinates.every(
          (ring) =>
            Array.isArray(ring) &&
            ring.length > 0 &&
            ring.every(
              (coord) =>
                Array.isArray(coord) &&
                coord.length === 2 &&
                coord.every((val) => typeof val === "number" && val !== null)
            )
        );
      case "MultiPolygon":
        return coordinates.every(
          (polygon) =>
            Array.isArray(polygon) &&
            polygon.every(
              (ring) =>
                Array.isArray(ring) &&
                ring.length > 0 &&
                ring.every(
                  (coord) =>
                    Array.isArray(coord) &&
                    coord.length === 2 &&
                    coord.every(
                      (val) => typeof val === "number" && val !== null
                    )
                )
            )
        );
      default:
        return false;
    }
  };

  const validFeatures = parsedGisData?.features?.filter((feature) => {
    if (!feature || !feature?.geometry) return false;

    return validateGeometry(feature.geometry);
  });

  const normalizedData = {
    ...parsedGisData,
    features: validFeatures,
  };

  return normalizedData;
};
